import React from 'react';
import { TabsProps } from "antd/lib/tabs";
import { useSearchParams } from "react-router-dom";

import { Tabs as TabsAnt } from "antd";
import './style.scss';

interface PropsInterface extends TabsProps {
  paramsKey?: string;
  styleType?: 'style1';
}

const Tabs = (props: PropsInterface) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const newProps = {...props};
  const paramsKey = props.paramsKey;

  let className = 'v-tabs';
  className = props.styleType ? `${className} v-tabs--${props.styleType}` : className;
  className = props.className ? `${className} ${props.className}` : className;

  delete newProps.styleType;
  delete newProps.paramsKey;

  function onChangeTab(e: any) {
    if (!paramsKey) {
      return;
    }

    searchParams.set(paramsKey, e);
    searchParams.delete('page');
    setSearchParams(searchParams)

    if (typeof props.onChange === 'function') {
      props.onChange(e);
    }
  }

  if (paramsKey) {
    newProps.onChange = onChangeTab;
    newProps.defaultActiveKey = searchParams.get(paramsKey) || props.defaultActiveKey || '';
  }

  return (
    <TabsAnt {...newProps} className={className}>
      {props.children}
    </TabsAnt>
  );
}

export default Tabs;
